export function memberCallbackFromLocation(locationUrl: string, membersOrigin: string): string {
  const normalizedMembersOrigin = membersOrigin.replace(/\/$/, "");
  const url = new URL(locationUrl);
  const candidate = url.searchParams.get("callback");
  if (!candidate) return `${normalizedMembersOrigin}/`;
  try {
    const parsed = new URL(candidate);
    return parsed.origin === normalizedMembersOrigin && !parsed.username && !parsed.password
      ? parsed.toString()
      : `${normalizedMembersOrigin}/`;
  } catch {
    return `${normalizedMembersOrigin}/`;
  }
}

export function hasAuthenticatedSession(payload: unknown): boolean {
  if (!payload || typeof payload !== "object") return false;
  const record = payload as Record<string, unknown>;
  return Boolean(record.session && typeof record.session === "object" && record.user && typeof record.user === "object");
}
